$(document).on('click', '[data-image-close]', function (ev) {
  ev.preventDefault();
  $(this).parents('.image__credits__overlay').css('display', 'none');
});

$(document).on('click', '[data-image-open]', function (ev) {
  ev.preventDefault();
  var target = $(this).attr('data-image-open');

  $(target).css('display', 'block');
});